module.exports = __webpack_public_path__ + "img/HNG-mob.16af5a93.jpg";